import type { FormikProps } from 'formik';
import type { ShowNotificationCommand } from 'utils/hooks/useNotifications';
import type { ApiPolicyFormValues } from './useApiPolicyFormik';
import type { AttributePolicyFormValues } from './useAttributePolicyFormik';

export const handlePolicyResourceConflict = (
  showNotification: (command: ShowNotificationCommand) => void,
  message: string,
  formik:
    | FormikProps<ApiPolicyFormValues>
    | FormikProps<AttributePolicyFormValues>,
): void => {
  showNotification({ message, type: 'warning' });

  formik.setFieldError('name', message);
};
